<!-- Google Tag Manager (noscript) -->
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5JN84XW" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>
<!-- End Google Tag Manager (noscript) -->

<div class="contenedor">
    <div class="col-md-12" id="header">
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-11 col-lg-offset-9 col-md-offset-9 col-sm-offset-9 ">
            <div class="col-lg-6 col-md-8 col-sm-9 col-xs-6">
                <img *ngIf="customer.id!=13 && customer.id!=18 && customer.id!=19 && customer.id!=20" src="./assets/imagenes agenda virtual/logo_cliente_agentamiento.png" alt="">
                <img *ngIf="customer.id==13 || customer.id==18 || customer.id==19 || customer.id==20" src="./assets/imagenes agenda virtual/logo_cliente_agentamiento-movistar-pe.png" alt="">
            </div>
            <div class="col-lg-6 col-md-4 col-sm-3 col-xs-6">
                <img src={{logo}} width="80px" alt="">
            </div>
        </div>
    </div>
    <div class="col-md-12" id="divider" [ngStyle]="{'background': customer.colour }"></div>
    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12  col-lg-offset-1 col-md-offset-1">
        <div *ngIf="customer.publicity && customer.id!=13 && customer.id!=20" class="col-lg-2 col-xl-1 col-md-2 col-sm-2 col-xs-12" id="bannerIzq">
            <img src="./assets/imagenes agenda virtual/frontalderecha1.jpg" alt="">
        </div>
        <div *ngIf="customer.id==13 || customer.id==18 || customer.id==19 || customer.id==20" class="col-lg-2 col-xl-1 col-md-2 col-sm-2 col-xs-12" id="bannerIzq">
            <img src="./assets/imagenes agenda virtual/movistar.png" alt="">
        </div>
        <div *ngIf="!customer.publicity" class="col-lg-2 col-xl-1 col-md-2 col-sm-2 col-xs-12" id="bannerIzq">

        </div>
        <div class="col-md-8 col-sm-8 col-xs-12" id="form">
            <div *ngIf="customer.id==22 || customer.id==23" style="margin-top: 10px;">
                <a [href]="customer.id == 22 ? '/agvirtual/ag/contigocof' : '/agvirtual/ag/contigoco'" style="text-decoration: none;">
                    <button type="button" class="btn btn-warning btn-block" style=" background-color: #f0670c; color: #fff;">
                        <div *ngIf="customer.id==23">
                            <i class="fa-solid fa-arrow-left" style="font-size: 1.5rem; margin-right: 8px;"></i>
                            Volver a controles
                        </div>
                        <div *ngIf=" customer.id==22">
                            Ingresa a Fuentes
                            <i class="fa-solid fa-arrow-right" style="font-size: 1.5rem; margin-right: 8px;"></i>
                        </div>
                    </button>
                </a>
            </div>
            <div class="col-md-12">
                <div class="col-md-6">
                    <label style="margin-top: 5px;">
                        <h4 style="color: #154c79;">{{title1}} </h4>
                    </label>
                </div>
                <div class="col-md-12">
                    <form #agendaForm="ngForm" name="agendaForm">
                        <!-- <hr class="col-md-12"> -->
                        <div *ngIf="this.customerGeneral == 'SI'; else notEqual">
                            <div class="col-md-4 col-sm-4">
                                <label> {{title2}} </label>
                                <input type="number" #scce="ngModel" name="scce" [(ngModel)]="identification" required>
                                <div style="color: orange;" *ngIf="agendaForm.controls['scce']&&agendaForm.controls['scce'].hasError('required')  && customer.id == 13">
                                    {{title2}} es requerido.
                                </div>
                            </div>
                        </div>
                        <ng-template #notEqual class="row form-group ">

                            <div class="col-md-6 col-sm-6  ">
                                <label> {{title2}} </label>
                                <input type="text" pattern="[0-9]*" #scce="ngModel" name="scce" [(ngModel)]="identification" (change)="getSubscriber(identification)" maxlength="10" required>
                                <div style="color: orange;" *ngIf="agendaForm.controls['scce']&&agendaForm.controls['scce'].hasError('required')">
                                    {{title2}} Es requerido.
                                </div>
                                <div style="color: red;" *ngIf="agendaForm.controls['scce'].hasError('maxlength') ">
                                    {{ title2 }} no puede tener más de 10 dígitos.
                                </div>
                                <div style="color: red;" *ngIf="scce.invalid && scce.dirty && scce.errors?.pattern">
                                    {{ title2 }} solo puede contener números.
                                </div>
                            </div>
                            <div class="col-md-2 col-sm-2" *ngIf="customer.id == 13 || customer.id == 10 || customer.id == 20">
                                <button class="btn btn-success" (click)="searchByIdentification()">
                                    <span class="fa fa-search" aria-hidden="true"> Buscar</span>
                                </button>
                            </div>

                        </ng-template>
                        <hr class="col-md-12">
                        <div class="row form-group">
                            <div *ngIf="customer.id==6" class="col-md-4 col-sm-4">
                                <label for=""> {{title3}} </label>
                                <input type="text" #scnc="ngModel" name="scnc" [(ngModel)]="schedule.company" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scnc'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div *ngIf="customer.id==6" class="col-md-4 col-sm-4">
                                <label for=""> {{title4}} </label>
                                <input type="text" #scna="ngModel" name="scna" [(ngModel)]="schedule.name" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scna'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div *ngIf="customer.id!=6" class="col-md-12 col-sm-12">
                                <label for=""> {{title4}} </label>
                                <input type="text" #scna="ngModel" name="scna" [(ngModel)]="schedule.name" pattern="[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scna']&&agendaForm.controls['scna'].hasError('required')">
                                    *obligatorio*
                                </span>
                                <span style="color: red;" *ngIf="agendaForm.controls['scna']&&agendaForm.controls['scna'].hasError('pattern') && agendaForm.controls['scna'].touched">
                                    Formato de  nombre no válido.
                                </span>
                            </div>
                            <br>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6 col-sm-6">
                                <label for=""> {{title5}} </label>
                                <input type="email" #scco="ngModel" name="scco" [(ngModel)]="schedule.email" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$">
                                <span style="color: orange;" *ngIf="agendaForm.controls['scco']&&agendaForm.controls['scco'].hasError('required')">
                                    *obligatorio*
                                </span>
                                <span style="color: red;" *ngIf="agendaForm.controls['scco']&&agendaForm.controls['scco'].hasError('pattern') && agendaForm.controls['scco'].touched">
                                    Formato de correo electrónico no válido.
                                </span>
                            </div>
                            <div class="col-md-3 col-sm-3" *ngIf="customer.id!=13">
                                <label for=""> {{title6}} </label>
                                <input type="number" #scph="ngModel" name="scph" [(ngModel)]="tel">
                            </div>
                            <div class="col-md-3 col-sm-3" *ngIf="customer.id ==13">
                                <label for=""> {{title6}} </label>
                                <input type="number" #scph="ngModel" name="scph" [(ngModel)]="tel" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scph'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div class="col-md-3 col-sm-3">
                                <label for=""> {{title7}} </label>
                                <input type="number" #scphm="ngModel" name="scphm" [(ngModel)]="telMovil" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scphm']&&agendaForm.controls['scphm'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-12 col-sm-12">
                                <label for=""> {{title8}} </label>
                                <input type="text" #scad="ngModel" name="scad" [(ngModel)]="schedule.address" (change)="changeAddress()" id="autocomplete" onFocus="geolocate()" required>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scad']&&agendaForm.controls['scad'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                        </div>

                        <!-- Anexar el campo nuevo, sin embargo cambia la busqueda de la provincia y el estado es el mismo -->
                        <div *ngIf="customer.provincia==1" class="row form-group">
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title17}} </label>
                                <p-dropdown #scde="ngModel" name="scde" [(ngModel)]="schedule.provinciaId" (onChange)="changeProvincia()" [options]="dropdownProvincias" [style]="{'width': '100%'}" [disabled]="!validateLocation" required></p-dropdown>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scde'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title9}} </label>
                                <p-dropdown #scde="ngModel" name="scde" [(ngModel)]="schedule.departmentId" [options]="dropdownDepartments" (onChange)="changeDepartment()" [style]="{'width': '100%'}" [disabled]="!validateLocation" required></p-dropdown>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scde'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title10}} </label>
                                <p-dropdown #scci="ngModel" name="scci" [(ngModel)]="citySelected" (onChange)="changeCity()" [options]="dropdownCities" [style]="{'width': '100%'}" [disabled]="!validateLocation" required></p-dropdown>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scci'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>

                        </div>
                        <div *ngIf="customer.provincia==1" class="row form-group">
                            <div class="col-md-9 col-sm-9 col-lg-12">
                                <label for=""> {{title16}} </label>
                                <input type="text" #scob="ngModel" name="scob" [(ngModel)]="schedule.observation">

                            </div>
                        </div>
                        <div *ngIf="customer.provincia == 0" class="row form-group">
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title9}} </label>
                                <p-dropdown #scde="ngModel" name="scde" [(ngModel)]="schedule.departmentId" [options]="dropdownDepartments" (onChange)="changeDepartment()" [style]="{'width': '100%'}" [disabled]="!validateLocation" required></p-dropdown>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scde']&&agendaForm.controls['scde'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title10}} </label>
                                <p-dropdown #scci="ngModel" name="scci" [(ngModel)]="citySelected" (onChange)="changeCity()" [options]="dropdownCities" [style]="{'width': '100%'}" [disabled]="!validateLocation" required></p-dropdown>
                                <span style="color: orange;" *ngIf="agendaForm.controls['scci']&&agendaForm.controls['scci'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title11}} </label>
                                <input type="text" #scne="ngModel" name="scne" [(ngModel)]="schedule.neighborhood" [disabled]="!validateLocation" [required]="customer.id==22||customer.id==23" />
                                <span style="color: orange;" *ngIf="agendaForm.controls['scne']&&agendaForm.controls['scne'].hasError('required')">
                                    *obligatorio*
                                </span>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title12}} </label>
                                <p-calendar *ngIf="customer.id != 13 && customer.id != 4 && customer.id != 3 && customer.id != 20" #scdp="ngModel" name="scdp" [(ngModel)]="schedule.datePickup" tabindex="0" [minDate]="minDate" [disabledDates]="invalidDates" [disabledDays]="[0,7]" [readonlyInput]="true"
                                    [numberOfMonths]="1" showIcon="true" [disabled]="!validateDate" [inputStyle]="{'width': '100%'}" [style]="{'width': '100%'}" required></p-calendar>
                                <p-calendar *ngIf="customer.id == 13 || customer.id == 4 || customer.id == 3 || customer.id == 20" #scdp="ngModel" name="scdp" [(ngModel)]="schedule.datePickup" tabindex="0" [minDate]="minDate" [disabledDates]="invalidDates" [disabledDays]="[0,7]" [readonlyInput]="true"
                                    [numberOfMonths]="1" showIcon="true" [disabled]="!validateDate" [inputStyle]="{'width': '100%'}" [style]="{'width': '100%'}" required></p-calendar>
                                <!--<p-calendar *ngIf="customer.id == 1 || customer.id == 3 || customer.id == 4 || customer.id == 7"
                                    #scdp="ngModel" name="scdp" [(ngModel)]="schedule.datePickup" tabindex="0"
                                    [minDate]="minDate" [maxDate]="maxDate" [disabledDates]="invalidDates"
                                    [disabledDays]="[0,4]" [readonlyInput]="true" [numberOfMonths]="1" showIcon="true"
                                    [disabled]="!validateDate" [inputStyle]="{'width': '100%'}"
                                    [style]="{'width': '100%'}" required></p-calendar>-->

                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title13}} </label>
                                <p-dropdown #scwd="ngModel" name="scwd" [(ngModel)]="schedule.workSheduleId" [options]="dropdownCustomerSchedule" [style]="{'width': '100%'}" (onClick)="selectHour()" [disabled]="!validateSchedule" [disabled]="!validateSchedule" required></p-dropdown>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for=""> {{title14}} </label>
                                <input type="number" #scqa="ngModel" name="scqa" [(ngModel)]="schedule.quantity" value="1" required>
                            </div>

                        </div>
                        <ng-container *ngIf="customer.id!=18 && customer.id!=19">
                            <div class="row form-group">
                                <div class="col-md-5 col-sm-3">
                                    <label for="">Medio de contacto</label>
                                    <p-dropdown #scont="ngModel" name="smtx" [(ngModel)]="contactMet" [options]="dropdownContact" [style]="{'width': '100%'}" optionLabel="name" required></p-dropdown>
                                    <span style="color: orange;" *ngIf="agendaForm.controls['smtx']&&agendaForm.controls['smtx'].hasError('required')">
                                        *obligatorio*
                                    </span>
                                </div>

                                <div class="col-md-3 col-sm-3" *ngIf="customer.id==22">
                                    <label for=""> Referencia Equipo </label>
                                    <p-dropdown #scont="ngModel" name="seqp" [(ngModel)]="equipoSelected" [options]="dropdownEquipments" (onChange)="getControls()" [style]="{'width': '100%'}" required></p-dropdown>
                                    <span style="color: orange;" *ngIf="agendaForm.controls['seqp']&&agendaForm.controls['seqp'].hasError('required')">
                                        *obligatorio*
                                    </span>
                                </div>

                                <div class="col-md-4 col-sm-3" *ngIf="customer.id==22">
                                    <label for=""> Referencia Control </label>
                                    <p-dropdown #scont="ngModel" name="scont" [(ngModel)]="controlSelected" [options]="dropdownControls" (onChange)="getEquipos()" [style]="{'width': '100%'}" required [disabled]="true"></p-dropdown>
                                    <span style="color: orange;" *ngIf="agendaForm.controls['scont']&&agendaForm.controls['scont'].hasError('required')">
                                        *obligatorio*
                                    </span>
                                </div>

                                <div class="col-md-3 col-sm-3" *ngIf="customer.id==23">
                                    <label for=""> Modelos:</label>
                                    <p-dropdown #scont="ngModel" name="fmod" [(ngModel)]="modelSelected" [options]="dropdownModelos" (onChange)="getAccesorios()" [style]="{'width': '100%'}" required></p-dropdown>
                                    <span style="color: orange;" *ngIf="agendaForm.controls['fmod']&&agendaForm.controls['fmod'].hasError('required')">
                                        *obligatorio*
                                    </span>
                                </div>

                                <div class="col-md-4 col-sm-3" *ngIf="customer.id==23">
                                    <label for=""> Accesorios:</label>
                                    <p-dropdown #scont="ngModel" name="scont" [(ngModel)]="accesorioSelected" [options]="dropdownAccesories" (onChange)="getAccesorios()" [style]="{'width': '100%'}" required [disabled]="true"></p-dropdown>
                                    <span style="color: orange;" *ngIf="agendaForm.controls['scont']&&agendaForm.controls['scont'].hasError('required')">
                                        *obligatorio*
                                    </span>
                                </div>

                            </div>
                            <div *ngIf="customer.provincia!=0" class="row form-group">
                                <div class="col-md-12 col-sm-12">
                                    <label for="">Observaciones</label>
                                    <input type="text" #scob="ngModel" name="scob" [(ngModel)]="schedule.observation">
                                </div>
                            </div>

                        </ng-container>

                        <div *ngIf="customer.id==6" class="row form-group">
                            <div class="col-md-9 col-sm-9 col-lg-12">
                                <label for=""> {{title15}} </label>
                                <input type="text" #scim="ngModel" name="scim" [(ngModel)]="schedule.imei">
                            </div>
                        </div>
                        <div *ngIf="customer.provincia==0" class="row form-group">
                            <div class="col-md-9 col-sm-9 col-lg-12">
                                <label for=""> {{title16}} </label>
                                <input type="text" #scob="ngModel" name="scob" [(ngModel)]="schedule.observation">
                            </div>
                        </div>
                        <div *ngIf="customer.policyData" class="row form-group" style="margin-bottom: 0px;">
                            <div class="col-md-1 col-sm-1 col-xs-1">
                                <p-checkbox #scap="ngModel" name="scap" [(ngModel)]="schedule.acceptP" binary="true" required></p-checkbox>
                            </div>
                            <div class="col-md-11 col-sm-11 col-xs-11">
                                <h5>He leido y acepto la <a href={{urlpolicy}} target="blank">Política de Tratamiento de
                                        datos </a></h5>
                            </div>
                        </div>
                        <div *ngIf="customer.sendInformation" class="row form-group" style="margin-bottom: 0px;">
                            <div class="col-md-1 col-sm-1 col-xs-1">
                                <p-checkbox #scae="ngModel" name="scae" [(ngModel)]="schedule.acceptE" binary="true">
                                </p-checkbox>
                            </div>
                            <div class="col-md-11 col-sm-11 col-xs-11">
                                <h5> Autorizo a <strong>WODEN</strong> enviar contenido informativo, comercial y de marketing a mi correo electrónico.</h5>
                            </div>
                        </div>
                        <input style="display: none;" type="file" #uploadF (change)="loadFile($event)" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        <div *ngIf="customer.id==6">
                            <button class="btn btn-success" (click)="uploadF.click()">
                                <span class="fa fa-upload" aria-hidden="true"></span>
                            </button>
                            <div class="col-lg-12">
                                <p-table #dt [columns]="cols" [value]="scheduleSerie" [resizableColumns]="true" columnResizeMode="expand" [autoLayout]="true" [paginator]="true" [rows]="10" [first]="first">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngFor="let col of columns">
                                                {{col.header}}
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                        <tr>
                                            <td *ngFor="let col of columns">
                                                {{rowData[col.field]}}
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="summary">
                                        Total Registros: {{scheduleSerie?.length}}
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-3">
                                <button *ngIf="customer.name=='CLARO' || customer.name=='CLARO - PERU'" class="btn btn-danger btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                    <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                                </button>
                                <button *ngIf="customer.name=='CLAROMOVIL'" class="btn btn-danger btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                    <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                                </button>
                                <button *ngIf="customer.name=='ETB'" class="btn btn-info btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                    <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                                </button>
                                <button *ngIf="customer.name=='TIGO' || customer.name=='TIGO - PANAMA' || customer.name==='TIGO SALVADOR'" class="btn btn-primary btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                    <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                                </button>
                                <button *ngIf="customer.name=='DIRECTV'" class="btn btn-secondary btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                    <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                                </button>
                            </div>
                            <button *ngIf="view" class="btn btn-success btn-block" (click)="createSchedule()" [disabled]="!agendaForm.form.valid || !schedule.acceptP">
                                <span class="fa fa-send" aria-hidden="true"> Enviar</span>
                            </button>

                        </div>

                    </form>
                </div>
            </div>
        </div>
        <div *ngIf="customer.id != 13">
            <div *ngIf="customer.publicity" class="col-md-2 col-sm-2 col-xs-12" id="bannerDer">
                <img src="./assets/imagenes agenda virtual/banner_agendamiento.jpg" alt="">
                <div *ngIf="citySelected != undefined" class="col-md-11 col-sm-11 col-xs-12" id="entrega" style="color:white; font-weight: bold;">
                    <a *ngIf="citySelected.id" class="text-center">Condiciones de la entrega:</a>
                    <h6 *ngIf="citySelected.id" class="text-center" style="margin-left: -14px; margin-right: 22px;">
                        Según su ubicación, la recolección se realizará <strong>{{this.citySelected.categoryDay}} días
                        </strong> hábiles después de la programación.</h6>
                </div>
            </div>
            <div *ngIf="!customer.publicity" class="col-md-2 col-sm-2 col-xs-12" id="bannerDer">
                <div *ngIf="citySelected != undefined" class="col-md-11 col-sm-11 col-xs-12" id="entrega" style="color:black; font-weight: bold;">
                    <p *ngIf="citySelected.id" class="text-center">Condiciones de la entrega:</p>
                    <h6 *ngIf="citySelected.id" class="text-center" style="margin-left: -14px; margin-right: 22px;">
                        Según su ubicación, la recolección se realizará <strong>{{this.citySelected.categoryDay}} días
                        </strong> hábiles después de la programación.</h6>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="customer.foot1!=''" class="col-lg-10 col-md-10 col-sm-12 col-xs-12  col-lg-offset-1 col-md-offset-1">
        <div id="footer1" class="text-center" style="margin-bottom: 10px;"></div>
    </div>
    <div *ngIf="customer.id==22" class="col-lg-10 col-md-10 col-sm-12 col-xs-12  col-lg-offset-1 col-md-offset-1">
        <div id="footer2" class="text-center"></div>
    </div>
    <div *ngIf="customer.whatsapp!=''" style="position: fixed;bottom:5px;left:20px;z-index:1000">
        <a href={{whatsapp}} target="_blank"><img src="./assets/images/whatsapp.png" width="55"></a>
    </div>


</div>